// @flow

import * as React from 'react';

import { Pizza } from './domain/pizza';
import PizzaCheese from './PizzaCheese';
import PizzaCrust from './PizzaCrust';
import PizzaSauce from './PizzaSauce';
import PizzaTopping from './PizzaTopping';

type Props = {
  pizza: Pizza,
  current?: 'crust' | 'sauce' | 'cheese' | number,
};

class PizzaContainer extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
  }

  render() {
    const { pizza, ...rest } = this.props;
    return (
      <div {...rest} className="pizza-image pizza-container">
        <PizzaCrust crust={pizza.crust} />
        <PizzaSauce sauce={pizza.sauce} />
        <PizzaCheese />
        <div className="pizza-topping-container">
          {pizza.toppings.map((topping, i) => {
            return <PizzaTopping topping={topping} key={i} />;
          })}
        </div>
      </div>
    );
  }
}

export default PizzaContainer;
